import { render } from "./applyDetail.vue?vue&type=template&id=4b7652ea&scoped=true"
import script from "./applyDetail.vue?vue&type=script&lang=js"
export * from "./applyDetail.vue?vue&type=script&lang=js"

import "./applyDetail.vue?vue&type=style&index=0&id=4b7652ea&lang=less&scoped=true"

import exportComponent from "/Users/yiduolanghua/Desktop/edu/visitor-h5-jy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b7652ea"]])

export default __exports__